export default "__VITE_ASSET__BJKy86GD__"